module.exports = "fonts/noto-sans-jp-v28-latin-700.woff2";